import { ReactElement, HTMLAttributes } from "react";
import { AppConstants } from "../../core/constants";
import { ProfilePic } from "../../assets";
import { FaFileAlt } from "react-icons/fa";
import { BsCheck2All } from "react-icons/bs";
interface Props extends HTMLAttributes<HTMLElement> {
  mine?: boolean;
  files?: any;
  text?: string;
  data?: string;
  applicant?: any;
  day?: string;
  hour?: string;
}

export function ChatItem({
  mine,
  files,
  day,
  hour,
  text,
  data,
  applicant,
}: Props): ReactElement {
  const getFile = (url: string) => {
    window.open(`${AppConstants.base_url_download}/${url}`, "_blank");
  };
  return (
    <div className={`${mine ? "my-chat" : ""} chat-item`}>
      <div className="chat-item-profile">
        <img
          src={ProfilePic}
          alt=""
          className="chat-item-profile-img"
          onError={(e: any) => {
            e.target.style.display = "none";
          }}
        />
        {applicant ? (
          <span className="chat-item-profile-username">{applicant}</span>
        ) : null}
      </div>
      <div className="chat-item-text-container">
        <div className="chat-item-bubble">
          <div className="chat-item-head">
            <span className="chat-item-head-applicant">
              <span className="chat-item-head-applicant-name">{applicant}</span>
            </span>
          </div>
          {text ? <div className="text">{text}</div> : null}
          {files && files.length > 0 ? (
            <div className="upload-btn-group">
              {files.map((item: any, index: number) => (
                <button
                  type="button"
                  key={index}
                  className="file-chip"
                  onClick={() => getFile(item.url)}
                  title="دانلود فایل پیوست"
                >
                  <FaFileAlt />
                  <span className="file-chip-name">
                    {item?.name || item?.title || "فایل پیوست"}
                  </span>
                </button>
              ))}
            </div>
          ) : null}
          <div className="meta-row">
            <span className="meta-row-date">{data}</span>
            <span className="meta-row-status">
              {mine ? <BsCheck2All /> : null}
              <span className="meta-row-time">
                {hour} {day}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatItem;
